/* deviceSyncing.js */

"use strict";
/* global Slick */
const _ = require("lodash");
const uiCore = require("@gluenetworks/steve_ui_core");
const {
    Control: {
        Action: {Button},
    },
} = uiCore;
const formatters = require("../../cellFormaters");
// const checkBoxEditor = require("../../cellEditors/CheckBoxEditor");
const FieldEditor = require("../../cellEditors/FieldEditor");
const SelectBoxEditor = require("../../cellEditors/SelectBoxEditor");

/**
 * Any functions named with NetToGlu belong to the second grid which is NetBox To Gluware.
 * Without it is for the Gluware to Netbox grid
 */
class DeviceSyncing {
    /**
     * Constructor
     * @param {*} model
     */
    constructor(model) {
        this._model = model;
        this._bindEventHandlers();

        this._tableOptions = this._initializeTableOptions();
        this._createEmptyBanners();

        this._deviceAndCiSyncingContainer = this._createSectionContainer(
            "nb-device-and-ci-syncing-container",
            "From Gluware to NetBox"
        );
        this._deviceAndCiSyncingContainerNetToGlu = this._createSectionContainer(
            "device-and-ci-syncing-n-t-g-container",
            "From NetBox to Gluware"
        );

        const slickTableDnCSContainerMain = document.createElement("slick-table-cmdb-container");
        const slickTableDnCSContainerMainNetToGlu = document.createElement(
            "slick-table-n-t-g-cmdb-container"
        );

        this._addNewRowDnCSButton = new Button({
            label: "Add Rule +",
            active: true,
        });

        this._addNewRowDnCSButton_NetToGlu = new Button({
            label: "Add Rule +",
            active: true,
        });

        this._slickTableDnCSContainer = document.createElement("slick-table-cmdb");
        this._slickTableDnCSContainer_NetToGlu = document.createElement("slick-table-cmdb");

        slickTableDnCSContainerMain.appendChild(this._slickTableDnCSContainer);
        slickTableDnCSContainerMainNetToGlu.appendChild(this._slickTableDnCSContainer_NetToGlu);

        const addRowButtonDnCSContainer = document.createElement("div");
        addRowButtonDnCSContainer.classList.add("add-new-rule-container");

        const addRowButtonDnCSContainer_NetToGlu = document.createElement("div");
        addRowButtonDnCSContainer_NetToGlu.classList.add("add-new-rule-container");

        slickTableDnCSContainerMain.appendChild(this._noMappingSyncing);
        slickTableDnCSContainerMain.appendChild(this._noVendorMapSyncing);
        // slickTableDnCSContainerMain.appendChild(this._noDataSyncing);

        slickTableDnCSContainerMainNetToGlu.appendChild(this._noMappingSyncing_NetToGlu);
        slickTableDnCSContainerMainNetToGlu.appendChild(this._noVendorMapSyncing_NetToGlu);
        // slickTableDnCSContainerMainNetToGlu.appendChild(this._noDataSyncing_NetToGlu);

        addRowButtonDnCSContainer.appendChild(this._addNewRowDnCSButton._renderer._rootElem);
        addRowButtonDnCSContainer_NetToGlu.appendChild(
            this._addNewRowDnCSButton_NetToGlu._renderer._rootElem
        );

        slickTableDnCSContainerMain.appendChild(addRowButtonDnCSContainer);
        slickTableDnCSContainerMainNetToGlu.appendChild(addRowButtonDnCSContainer_NetToGlu);

        this._slickDnCSTable = undefined;
        this._slickDnCSTable_NetToGlu = undefined;

        this._columnsDnCS = [
            {
                id: "gwPropPath",
                width: 350,
                name: "Gluware Property",
                field: "gwPropPath",
                resizable: true,
                toolTip: "Gluware Property",
                formatter: formatters.fieldFormatter,
                editor: FieldEditor,
            },
            {
                id: "cmdbAttr",
                width: 350,
                name: "NetBox Property",
                field: "cmdbAttr",
                resizable: true,
                toolTip: "NetBox Property",
                formatter: formatters.ciNetBoxAttributeFormatter,
                editor: SelectBoxEditor,
            },
            {
                id: "deleteRow",
                width: 90,
                name: "Action",
                field: "deleteRow",
                selectable: false,
                resizable: false,
                cssClass: "cell-delete dnd centered",
                formatter: formatters.deleteButtonFormatter,
                headerCssClass: "centered",
            },
        ];

        this._columnsDnCS_NetToGlu = [
            {
                id: "cmdbAttr",
                width: 350,
                name: "NetBox Property",
                field: "cmdbAttr",
                resizable: true,
                toolTip: "NetBox Property",
                formatter: formatters.ciNetBoxAttributeFormatter,
                editor: SelectBoxEditor,
            },
            {
                id: "gwPropPath",
                width: 350,
                name: "Gluware Property",
                field: "gwPropPath",
                resizable: true,
                toolTip: "Gluware Property",
                formatter: formatters.fieldFormatter,
                editor: FieldEditor,
            },
            {
                id: "deleteRow",
                width: 90,
                name: "Action",
                field: "deleteRow",
                selectable: false,
                resizable: false,
                cssClass: "cell-delete dnd centered",
                formatter: formatters.deleteButtonFormatter,
                headerCssClass: "centered",
            },
        ];

        this._deviceAndCiSyncingContainer.appendChild(slickTableDnCSContainerMain);
        this._deviceAndCiSyncingContainerNetToGlu.appendChild(slickTableDnCSContainerMainNetToGlu);

        this._registerEventListeners();
    }

    // INITIALIZATION HELPERS - START

    _bindEventHandlers() {
        this._onDnCSRowCountChange = this._onDnCSRowCountChange.bind(this);
        this._onDnCSCellChangeAction = this._onDnCSCellChangeAction.bind(this);
        this._onDnCSRowsChanged = this._onDnCSRowsChanged.bind(this);

        this._onDnCSRowCountChange_NetToGlu = this._onDnCSRowCountChange_NetToGlu.bind(this);
        this._onDnCSCellChangeAction_NetToGlu = this._onDnCSCellChangeAction_NetToGlu.bind(this);
        this._onDnCSRowsChanged_NetToGlu = this._onDnCSRowsChanged_NetToGlu.bind(this);

        this._documentClickHandler = this._documentClickHandler.bind(this);
    }

    _initializeTableOptions() {
        return {
            editable: true,
            enableCellNavigation: true,
            enableAsyncPostRender: true,
            forceFitColumns: true,
            autoHeight: false,
            autoEdit: true,
            resizable: false,
            rowHeight: 40,
        };
    }

    _createEmptyBanners() {
        this._noDataSyncing = this._createEmptyBanner(
            "Unable to connect to NetBox. Please verify configured connection details.",
            "no-cmdb-device-syncing-connection"
        );
        this._noVendorMapSyncing = this._createEmptyBanner(
            "No Vendor OS Map available for the Organization.",
            "no-vendor-map"
        );
        this._noMappingSyncing = this._createEmptyBanner(
            "No Syncing Rules Specified.",
            "no-mapping"
        );

        this._noDataSyncing_NetToGlu = this._createEmptyBanner(
            "Unable to connect to NetBox. Please verify configured connection details.",
            "no-cmdb-device-syncing-n-t-g-connection"
        );
        this._noVendorMapSyncing_NetToGlu = this._createEmptyBanner(
            "No Vendor OS Map available for the Organization.",
            "no-vendor-map"
        );
        this._noMappingSyncing_NetToGlu = this._createEmptyBanner(
            "No Syncing Rules Specified.",
            "no-mapping"
        );
    }

    _createSectionContainer(className, titleText) {
        const container = document.createElement("div");
        container.classList.add(className);

        const sectionTitle = document.createElement("div");
        sectionTitle.classList.add("section-title");
        sectionTitle.innerText = titleText;

        container.appendChild(sectionTitle);
        return container;
    }

    // INITIALIZATION HELPERS - END

    // EVENT REGISTRATIONS - START
    _registerEventListeners() {
        this._addNewRowDnCSButton.on(
            "UserClick",
            (this._addD2CSyncingClick = this._addD2CSyncingClick.bind(this))
        );
        this._addNewRowDnCSButton_NetToGlu.on(
            "UserClick",
            (this._addD2CSyncingNetToGluClick = this._addD2CSyncingNetToGluClick.bind(this))
        );
        this._model.on(
            "RefreshDeviceAndCiSyncingGrid",
            (this.resetDnCSSlickTable = this.resetDnCSSlickTable.bind(this, "gw_to_nb"))
        );
        this._model.on(
            "RefreshDeviceAndCiSyncingNetToGluGrid",
            (this.resetDnCSNetToGluSlickTable = this.resetDnCSNetToGluSlickTable.bind(
                this,
                "nb_to_gw"
            ))
        );
        this._model.on("ErrorInSyncing", (this._errorInSyncing = this._errorInSyncing.bind(this)));
        this._model.on(
            "ErrorInSyncingNetToGlu",
            (this._errorInSyncing_NetToGlu = this._errorInSyncing_NetToGlu.bind(this))
        );
    }

    _unregisterEventListeners() {
        this._addNewRowDnCSButton.removeListener("UserClick", this._addD2CSyncingClick);
        this._addNewRowDnCSButton_NetToGlu.removeListener(
            "UserClick",
            this._addD2CSyncingNetToGluClick
        );
        this._model.removeListener("RefreshDeviceAndCiSyncingGrid", this.resetDnCSSlickTable);
        this._model.removeListener(
            "RefreshDeviceAndCiSyncingNetToGluGrid",
            this.resetDnCSNetToGluSlickTable
        );
        this._model.removeListener("ErrorInSyncingNetToGlu", this._errorInSyncing_NetToGlu);
        this._model.removeListener("ErrorInSyncing", this._errorInSyncing);

        this._unregisterDocumentListener();
    }

    _registerDocumentListener() {
        document.addEventListener("click", this._documentClickHandler);
    }

    _unregisterDocumentListener() {
        document.removeEventListener("click", this._documentClickHandler);
    }

    // EVENT REGISTRATIONS - END

    // SLICK EVENT REGISTRATIONS - START

    _registerDnCSSlickTableListeners(type = "gw_to_nb") {
        const typeAppend = type === "gw_to_nb" ? "" : "_NetToGlu";
        if (this["_slickDnCSTable" + typeAppend]) {
            this["_slickDnCSTable" + typeAppend].onCellChange.subscribe(
                this["_onDnCSCellChangeAction" + typeAppend]
            );
            this["_slickDnCSDataVIew" + typeAppend].onRowCountChanged.subscribe(
                this["_onDnCSRowCountChange" + typeAppend]
            );
            this["_slickDnCSDataVIew" + typeAppend].onRowsChanged.subscribe(
                this["_onDnCSRowsChanged" + typeAppend]
            );
        }
    }

    // SLICK EVENT REGISTRATIONS - END

    // EVENTS - START

    _addD2CSyncingClick() {
        this._model.addNewD2CSyncingRule();
    }
    _addD2CSyncingNetToGluClick() {
        this._model.addNewD2CSyncingNetToGluRule();
    }

    _errorInSyncing(ids = []) {
        ids.forEach((id) => {
            const rowIndex = this._slickDnCSTable.getData().getIdxById(id);
            const currentRow = this._slickDnCSTable.getCanvasNode().children[rowIndex];
            if (currentRow) {
                currentRow.classList.add("error-row");
            }
        });
    }
    _errorInSyncing_NetToGlu(ids = []) {
        ids.forEach((id) => {
            const rowIndex = this._slickDnCSTable_NetToGlu.getData().getIdxById(id);
            const currentRow = this._slickDnCSTable_NetToGlu.getCanvasNode().children[rowIndex];
            if (currentRow) {
                currentRow.classList.add("error-row");
            }
        });
    }

    _documentClickHandler(evt) {
        this._saveAndCloseEditCellAction(evt);
    }

    // EVENTS - END

    // RENDER METHODS - START

    _getdeviceCISyncingContent() {
        const _tabMainContent = document.createElement("div");
        _tabMainContent.classList.add("content-main", "nb-device-to-ci-syncing");

        _tabMainContent.appendChild(this._deviceAndCiSyncingContainer);
        _tabMainContent.appendChild(this._deviceAndCiSyncingContainerNetToGlu);

        _tabMainContent.appendChild(this._noDataSyncing);

        this._tabContent = _tabMainContent;
        return this._tabContent;
    }

    _createEmptyBanner(msg, className) {
        const msgContainer = document.createElement("div");
        msgContainer.classList.add(className);
        const innerSpan = document.createElement("span");
        innerSpan.innerText = msg;

        msgContainer.appendChild(innerSpan);

        return msgContainer;
    }

    _createNoDataPlaceholder() {
        const noDataPlaceholder = document.createElement("div");
        noDataPlaceholder.classList.add("no-data-placeholder");
        noDataPlaceholder.innerText = "No Sync Rules Available";
        return noDataPlaceholder;
    }

    /**
     * Shows banner if no mappings
     */
    _entityContainsMapping(type = "gw_to_nb") {
        const typeAppend = type === "gw_to_nb" ? "" : "_NetToGlu";
        const dataForSyncMapping = this._model._nbDataSyncConfigEntity.getDataSyncMappings() || {},
            deviceValueMaps = _.get(dataForSyncMapping, "valueMapping.device", []);
        if (_.isEmpty(deviceValueMaps)) {
            this["_noMappingSyncing" + typeAppend].classList.add("show");
        } else {
            this["_noMappingSyncing" + typeAppend].classList.remove("show");
        }
    }

    /**
     * Shows empty banner if no data to show
     * @param {*} state
     * @param {*} container
     */
    _toggleNoDataPlaceholder(state, container, type = "gw_to_nb") {
        const typeAppend = type === "gw_to_nb" ? "" : "_NetToGlu";
        container.classList.toggle("empty", state);
        if (!state) {
            this["_noMappingSyncing" + typeAppend].classList.remove("show");
        }
    }

    _renderDnCSSlickGrid(data, type = "gw_to_nb") {
        const typeAppend = type === "gw_to_nb" ? "" : "_NetToGlu";

        if (!this["_slickDnCSTable" + typeAppend]) {
            // slick-table-height-hack class with a large height is added before render
            // to provide slick grid with fixed large height and then removed after render
            // to fix the issue mentioned in JIRA PE-14385 (see also PE-12890 for xDome)
            this["_slickTableDnCSContainer" + typeAppend].classList.add("slick-table-height-hack");
            this["_slickDnCSDataVIew" + typeAppend] = new Slick.Data.DataView();
            this["_slickDnCSDataVIew" + typeAppend].setItems(data || []);
            this["_slickDnCSTable" + typeAppend] = new Slick.Grid(
                this["_slickTableDnCSContainer" + typeAppend],
                this["_slickDnCSDataVIew" + typeAppend],
                this["_columnsDnCS" + typeAppend],
                this["_tableOptions"]
            );
            setTimeout(() => {
                this["_slickTableDnCSContainer" + typeAppend].classList.remove(
                    "slick-table-height-hack"
                );
            }, 0);

            this._registerDnCSSlickTableListeners(type);

            this["_slickTableDnCSContainer" + typeAppend].appendChild(
                this._createNoDataPlaceholder()
            );
        }
    }

    // RENDER METHODS - END

    // SLICK DELETE ACTION - START
    _deleteDnCSItem(id, type, propName) {
        const deleteConfirmation = () => {
            const deleteMessage = `Are you sure you want to delete '${propName}' from the sync process?`;

            return this._model._uiUtils.showDeleteConfirmDialog({
                message: deleteMessage,
                confirmButtonName: "Confirm",
                cancelButtonName: "Cancel",
            });
        };

        return deleteConfirmation()
            .then(() => {
                this._model.deleteInstanceSyncingCriteria(id, type);
                if (type === "GW_TO_NB") {
                    this._slickDnCSDataVIew.deleteItem(id);
                    this._slickDnCSTable.invalidate();
                } else {
                    this._slickDnCSDataVIew_NetToGlu.deleteItem(id);
                    this._slickDnCSTable_NetToGlu.invalidate();
                }

                this._model.setDataSyncMappings();
                this._model.emit("validateCMDBSyncIntegrations");
            })
            .catch((error) => error && this._showError(error));
    }

    // SLICK DELETE ACTION - END

    // HELPER METHODS - START

    resetDnCSSlickTable(type = "gw_to_nb") {
        const typeAppend = type === "gw_to_nb" ? "" : "_NetToGlu";
        if (this["_slickDnCSTable" + typeAppend]) {
            if (!_.isUndefined(this._model["_dataForSlickTableSyncing" + typeAppend])) {
                this["_slickDnCSDataVIew" + typeAppend].setItems(
                    this._model["_dataForSlickTableSyncing" + typeAppend]
                );
                // this._sortTable();

                this["_slickDnCSTable" + typeAppend].invalidate();

                this["_slickDnCSTable" + typeAppend].render();

                this["_slickDnCSTable" + typeAppend].resizeCanvas();

                this._model.emit("validateCMDBSyncIntegrations");

                this._errorInSyncing(this._model["errSyncingIds" + typeAppend]);
                this._toggleNoDataPlaceholder(
                    !this._model["_dataForSlickTableSyncing" + typeAppend].length,
                    this["_slickTableDnCSContainer" + typeAppend],
                    "gw_to_nb"
                );
            }
        } else {
            this._renderDnCSSlickGrid(this._model["_dataForSlickTableSyncing" + typeAppend], type);
        }
    }

    resetDnCSNetToGluSlickTable() {
        const typeAppend = "_NetToGlu";
        if (this["_slickDnCSTable" + typeAppend]) {
            // slick-table-height-hack class with a large height is added before render
            // to provide slick grid with fixed large height and then removed after render
            // to fix the issue mentioned in JIRA PE-14385 (see also PE-12890 for xDome)
            this["_slickTableDnCSContainer" + typeAppend].classList.add("slick-table-height-hack");
            if (!_.isUndefined(this._model["_dataForSlickTableSyncing" + typeAppend])) {
                this["_slickDnCSDataVIew" + typeAppend].setItems(
                    this._model["_dataForSlickTableSyncing" + typeAppend]
                );
                // this._sortTable();

                this["_slickDnCSTable" + typeAppend].invalidate();

                this["_slickDnCSTable" + typeAppend].render();

                this["_slickDnCSTable" + typeAppend].resizeCanvas();
                setTimeout(() => {
                    this["_slickTableDnCSContainer" + typeAppend].classList.remove(
                        "slick-table-height-hack"
                    );
                }, 0);

                this._model.emit("validateCMDBSyncIntegrations");

                this._errorInSyncing(this._model["errSyncingIds" + typeAppend]);
                this._toggleNoDataPlaceholder(
                    !this._model["_dataForSlickTableSyncing" + typeAppend].length,
                    this["_slickTableDnCSContainer" + typeAppend],
                    "gw_to_nb"
                );
            }
        } else {
            this._renderDnCSSlickGrid(
                this._model["_dataForSlickTableSyncing" + typeAppend],
                "nb_to_gw"
            );
        }
    }

    async _resetDnCSData() {
        await this._model._generateSlickDataForInstanceSyncing();
    }

    /**
     * Sets the valuedata in the entity and triggers a validation to enable/disable the save/cancel buttons
     */
    _setDnCSInEntityAndEnableDisableActions() {
        this._model.setDataSyncMappings();
        this._model.emit("validateCMDBSyncIntegrations");
    }

    /**
     * This method is first called when the Device Syncing Tab is clicked.
     * From here, the rest of the flow continues
     */
    _tabClick() {
        this._registerDocumentListener();

        this._renderDnCSSlickGrid(undefined, "gw_to_nb");
        this._renderDnCSSlickGrid(undefined, "nb_to_gw");

        this._slickDnCSTable_NetToGlu.resizeCanvas();
        this._slickDnCSTable.resizeCanvas();

        this._reapplyErrorRows();
    }

    _saveAndCloseEditCellAction(e) {
        //do nothing if no active editors
        const slickTables = [this._slickDnCSTable, this._slickDnCSTable_NetToGlu];
        const tablesWithActiveEditors = slickTables.filter((table) =>
            table.getEditorLock().isActive()
        );
        if (tablesWithActiveEditors.length === 0) {
            return false;
        }
        tablesWithActiveEditors.forEach((table) => {
            //get event bubbling path
            const path = e.path || e.composedPath();
            //check if click was outside of current editing cell
            let outsideClick = true;
            _.each(path, (element) => {
                const elHasClass = (className) =>
                    element.classList && element.classList.contains(className);
                if (elHasClass("slick-cell")) {
                    const cellHasActiveEditor = elHasClass("active") && elHasClass("editable");
                    outsideClick = !cellHasActiveEditor;
                    return false;
                }
                if (element.tagName === "SLICK-TABLE-CMDB") {
                    return false;
                }
            });
            if (outsideClick) {
                table.getEditorLock().commitCurrentEdit();
            }
        });
    }

    _connectionFailed() {
        this._noDataSyncing.classList.add("show");
        this._tabContent.classList.add("no-connection");
    }

    _connectionPassed() {
        this._noDataSyncing.classList.remove("show");
        this._tabContent.classList.remove("no-connection");
    }

    // HELPER METHODS - END

    /* SLICK EVENTS : START */

    _onDnCSRowCountChange(event, {/*previous,*/ current}) {
        this._slickDnCSDataVIew.refresh();
        this._toggleNoDataPlaceholder(!current, this._slickTableDnCSContainer, "gw_to_nb"); // Create new no data holder
    }
    _onDnCSRowsChanged() {
        this._model.emit("validateCMDBSyncIntegrations");
    }
    _onDnCSCellChangeAction() {
        this._setDnCSInEntityAndEnableDisableActions();
        this._reapplyErrorRows();
    }

    _onDnCSRowCountChange_NetToGlu(event, {/*previous,*/ current}) {
        this._slickDnCSDataVIew_NetToGlu.refresh();
        this._toggleNoDataPlaceholder(!current, this._slickTableDnCSContainer_NetToGlu, "nb_to_gw"); // Create new no data holder
    }
    _onDnCSRowsChanged_NetToGlu() {
        this._model.emit("validateCMDBSyncIntegrations");
    }
    _onDnCSCellChangeAction_NetToGlu() {
        this._setDnCSInEntityAndEnableDisableActions();
        this._reapplyErrorRows();
    }

    _reapplyErrorRows() {
        if (this._slickDnCSTable) {
            const slickRows = this._slickDnCSTable.getCanvasNode().children;
            for (const currentRow of slickRows) {
                currentRow.classList.remove("error-row");
            }
        }
        if (this._slickDnCSTable_NetToGlu) {
            const slickRows = this._slickDnCSTable_NetToGlu.getCanvasNode().children;
            for (const currentRow of slickRows) {
                currentRow.classList.remove("error-row");
            }
        }
        if (!_.isEmpty(this._model.errSyncingIds)) {
            this._model.emit("ErrorInSyncing", this._model.errSyncingIds);
        }
        if (!_.isEmpty(this._model.errSyncingIds_NetToGlu)) {
            this._model.emit("ErrorInSyncingNetToGlu", this._model.errSyncingIds_NetToGlu);
        }
    }

    /* SLICK EVENTS : END */
}

module.exports = DeviceSyncing;
